import { IHocSinhAceChiTietLoadStart } from "../../../models/request/hoc-sinh/IHocSinhAceChiTietLoadStart";
import { IHocSinhAceChiTietSubmit } from "../../../models/request/hoc-sinh/IHocSinhAceChiTietSubmit";
import { IHocSinhAceChitiet, IHocSinhAceChitietVM } from "../../../models/response/hoc-sinh/IHocSinhAceChitiet";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objHocSinhAceChiTietDefine = {
    LOAD_START: {} as IHocSinhAceChiTietLoadStart,
    LOAD_SUCCESS: [] as IHocSinhAceChitietVM[],
    LOAD_ERROR: "",
    SHOW_EDIT_MODAL: {} as IHocSinhAceChitiet | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IHocSinhAceChiTietSubmit,
    SAVE_SUCESS: {} as IHocSinhAceChitiet,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};

export const eHocSinhAceChiTietActionTypeIds = generateActionTypeIds(objHocSinhAceChiTietDefine, "HOC_SINH_ACE_CHI_TIET")
export type IHocSinhAceChiTietActionTypes = IGenericActionType<typeof objHocSinhAceChiTietDefine, "HOC_SINH_ACE_CHI_TIET">
